// extracted by mini-css-extract-plugin
export default {"root":"_2Ffi2QmP","column":"zkladP1A","item":"_1+lM7Q5q","link":"PJCpEpRm","isMarked":"_7XFew3Et"};